export default __webpack_public_path__ + "static/media/ava-1.c185d772.jpg";